import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useDelivery from '../../../useDelivery';
import {
  TransportWithCustomWeightDiffDialogStyledContainer,
  TransportWithCustomWeightDiffStyledContainer,
} from './StyledComponents';

const TransportWithCustomWeightDiffDialog = () => {
  const { t } = useTranslation(['RoutesCalculationWidget']);

  const {
    useIsTransportWithCustomWeightDiff,
    useIsStartSearchWithWeightDiff,
    actions: { createAndRunRouteSearchTask },
  } = useDelivery();
  const [isTransportWithCustomWeightDiff, setIsTransportWithCustomWeightDiff] =
    useIsTransportWithCustomWeightDiff().useState();
  const setIsStartSearchWithWeightDiff = useIsStartSearchWithWeightDiff().setState;

  const changeSearchParamsHandler = () => {
    setIsTransportWithCustomWeightDiff(false);
  };

  const continueSearchHandler = () => {
    setIsTransportWithCustomWeightDiff(false);
    setIsStartSearchWithWeightDiff(true);
    createAndRunRouteSearchTask(true);
  };

  return (
    <>
      <TransportWithCustomWeightDiffDialogStyledContainer
        fullWidth
        maxWidth={'sm'}
        open={isTransportWithCustomWeightDiff}
        scroll={'body'}
      >
        <TransportWithCustomWeightDiffStyledContainer>
          <Typography variant={'subtitle1'}>
            {t('RoutesCalculationWidget:FclFtlWeightDifference.Title')}
          </Typography>
          <div className="controls-wrapper">
            <Button
              onClick={changeSearchParamsHandler}
              color={'primary'}
              variant={'outlined'}
              size={'medium'}
            >
              {t('RoutesCalculationWidget:FclFtlWeightDifference.ChangeParamsButton')}
            </Button>
            <Button
              onClick={continueSearchHandler}
              color={'primary'}
              variant={'contained'}
              size={'medium'}
              className="continue-search-btn"
            >
              {t('RoutesCalculationWidget:FclFtlWeightDifference.ContinueSearchButton')}
            </Button>
          </div>
        </TransportWithCustomWeightDiffStyledContainer>
      </TransportWithCustomWeightDiffDialogStyledContainer>
    </>
  );
};

export default TransportWithCustomWeightDiffDialog;
